export default "__VITE_ASSET__Ckt5Jwg$__"